import React from "react";
import { ApplicationUser } from "../entities/ApplicationUser";

export const AuthenticatedUserContext = React.createContext<ApplicationUser>({} as any);

export function useAuthenticatedUser() {
	return React.useContext(AuthenticatedUserContext);
}